export default "__VITE_ASSET__BUUBs6io__"